import { useState } from 'react';

function useAtaModal() {
  const [showAtaModal, setShowAtaModal] = useState(false);

  const openAtaModal = () => {
    setShowAtaModal(true);
  };

  const closeAtaModal = () => {
    setShowAtaModal(false);
  };

  return {
    showAtaModal,
    openAtaModal,
    closeAtaModal,
  };
}

export default useAtaModal;
